export enum KindPage {
	FoliarTankmix = "Foliar Tankmix",
	SeedCoating = "Seed Coating"
}
